module.exports = __webpack_public_path__ + "img/device-2@2x.6759b39b.png";